export default __webpack_public_path__ + "static/line-with-gaps-14ec4c75951890da82b182952743c0a8.png";